import { combineReducers } from 'redux';
import { dataReducer, DataState } from './data';
import { legalEntitiesReducer, LegalEntitiesState } from './legalEntities';
import { uiReducer, UIState } from './ui';

export interface RootState {
  data: DataState;
  ui: UIState;
  legalEntities: LegalEntitiesState;
}

const rootReducer = () =>
  combineReducers({
    data: dataReducer,
    ui: uiReducer,
    legalEntities: legalEntitiesReducer
  });

export default rootReducer;
